
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Produtos from "../pages/produtos/page";
import Receitas from "../pages/receitas/page";
import Catalogos from "../pages/catalogos/page";
import Contato from "../pages/contato/page";
import Sobre from "../pages/sobre/page";
import Noticias from "../pages/noticias/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produtos",
    element: <Produtos />,
  },
  {
    path: "/receitas",
    element: <Receitas />,
  },
  {
    path: "/catalogos",
    element: <Catalogos />,
  },
  {
    path: "/sobre",
    element: <Sobre />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/noticias",
    element: <Noticias />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
